var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeStretching = function SvgTimeStretching(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.984 1.556c-1.8.179-3.458.835-4.849 1.84l.586.81a8.95 8.95 0 0 1 4.363-1.655zM13.442 2.845a9.004 9.004 0 0 1 .07 17.302l.281.96c4.156-1.213 7.194-5.052 7.194-9.6 0-4.579-3.076-8.437-7.273-9.624zM2.69 5.92a9.95 9.95 0 0 0-1.663 4.678l.996.09A8.95 8.95 0 0 1 3.52 6.48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.78 8.37a.844.844 0 0 0-1.268.733v4.806a.844.844 0 0 0 1.267.732l4.126-2.402a.848.848 0 0 0 0-1.465zM1.363 14.233a10 10 0 0 0 1.897 3.621l.772-.635a9 9 0 0 1-1.707-3.258zM5.986 20.168a9.94 9.94 0 0 0 4.092 1.297l.09-.995a8.9 8.9 0 0 1-3.681-1.168z"
  })));
};
export default SvgTimeStretching;